import { render } from "./AdrAdmin.vue?vue&type=template&id=48ec6e3b"
import script from "./AdrAdmin.vue?vue&type=script&lang=js"
export * from "./AdrAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__